import styled from "styled-components";
import { pxToRem } from "../../../utils/pxToRem";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  > h1 {
    text-align: center;
  }

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const FormModal = styled.form`
  width: 100%;
  max-width: ${pxToRem(800)};
  margin: 0 auto;
`;

export const GridModal = styled.div`
  width: 100%;
  display: grid;
  gap: 2rem 1rem;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: "nome nome" "cpf cpf" "email email" "telefone telefone" "cep cep" "rua rua" "numero complemento" "bairro bairro" "uf cidade" "button button";

  > :nth-child(1) {
    grid-area: nome;
  }

  > :nth-child(2) {
    grid-area: cpf;
  }

  > :nth-child(3) {
    grid-area: email;
  }

  > :nth-child(4) {
    grid-area: telefone;
  }

  > :nth-child(5) {
    grid-area: cep;
  }

  > :nth-child(6) {
    grid-area: rua;
  }

  > :nth-child(7) {
    grid-area: numero;
  }

  > :nth-child(8) {
    grid-area: bairro;
  }

  > :nth-child(9) {
    grid-area: complemento;
  }

  > :nth-child(10) {
    grid-area: uf;
  }

  > :nth-child(11) {
    grid-area: cidade;
  }

  > :nth-child(12) {
    grid-area: button;

    display: flex;
    justify-content: center;
    gap: 0 48px;
  }

  @media (min-width: 640px) {
    grid-template-columns: repeat(6, 1fr);
    gap: 2.31rem 1rem;
    padding: 2rem 1rem;
    grid-template-areas: "nome nome nome nome nome nome" "cpf cpf cpf telefone telefone telefone" "email email email cep cep cep" "rua rua rua rua rua rua" "numero numero numero complemento complemento complemento" "bairro bairro uf uf cidade cidade" ". . button button . .";
  }
`;
